import React from "react";
import PretendardText from "../../../../component/atoms/text/pretendardText";

const CancelReasonCustomTooltip = ({ active, payload }) => {
  // 스타일 객체
  const circleStyle = {
    width: "18px",
    height: "18px",
    borderRadius: "50%",
  };

  const getCellColor = (title) => {
    switch (title) {
      case "결제 방식이나 멤버십 서비스를 변경하고 싶어요":
        return "#cf6679";
      case "기대했던 것과 콘텐츠의 내용이 달라요":
        return "#1b5ddd";
      case "가격이 부담돼요":
        return "#ffa438";
      case "이용을 잘 안해요":
        return "#53bd20";
      case "구매자를 위한 혜택이 부족해요":
        return "#46a196";
      case "기타":
        return "#b658ff";
      default:
        return "#f3f3f3";
    }
  };

  if (active && payload && payload.length) {
    return (
      <div
        style={{
          width: "fit-content",
          height: "fit-content",
          backgroundColor: "#313233",
          padding: "10px 12px",
          border: "1px solid rgba(255, 255, 255, 0.12)",
          boxShadow: "1px 1px 4px 0px rgba(0, 0, 0, 0.12)",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "5px",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "5px",
            }}
          >
            <span
              style={{
                ...circleStyle,
                backgroundColor: getCellColor(
                  "결제 방식이나 멤버십 서비스를 변경하고 싶어요"
                ),
              }}
            />
            <PretendardText
              style={{
                fontWeight: 600,
                fontSize: "14px",
                lineHeight: "22.75px",
                color: "#aaa",
              }}
            >
              결제 방식이나 멤버십 서비스를 변경하고 싶어요
            </PretendardText>
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "5px",
            }}
          >
            <span
              style={{
                ...circleStyle,
                backgroundColor: getCellColor(
                  "기대했던 것과 콘텐츠의 내용이 달라요"
                ),
              }}
            />
            <PretendardText
              style={{
                fontWeight: 600,
                fontSize: "14px",
                lineHeight: "22.75px",
                color: "#aaa",
              }}
            >
              기대했던 것과 콘텐츠의 내용이 달라요
            </PretendardText>
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "5px",
            }}
          >
            <span
              style={{
                ...circleStyle,
                backgroundColor: getCellColor("가격이 부담돼요"),
              }}
            />
            <PretendardText
              style={{
                fontWeight: 600,
                fontSize: "14px",
                lineHeight: "22.75px",
                color: "#aaa",
              }}
            >
              가격이 부담돼요
            </PretendardText>
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "5px",
            }}
          >
            <span
              style={{
                ...circleStyle,
                backgroundColor: getCellColor("이용을 잘 안해요"),
              }}
            />
            <PretendardText
              style={{
                fontWeight: 600,
                fontSize: "14px",
                lineHeight: "22.75px",
                color: "#aaa",
              }}
            >
              이용을 잘 안해요
            </PretendardText>
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "5px",
            }}
          >
            <span
              style={{
                ...circleStyle,
                backgroundColor: getCellColor("구매자를 위한 혜택이 부족해요"),
              }}
            />
            <PretendardText
              style={{
                fontWeight: 600,
                fontSize: "14px",
                lineHeight: "22.75px",
                color: "#aaa",
              }}
            >
              구매자를 위한 혜택이 부족해요
            </PretendardText>
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "5px",
            }}
          >
            <span
              style={{
                ...circleStyle,
                backgroundColor: getCellColor("기타"),
              }}
            />
            <PretendardText
              style={{
                fontWeight: 600,
                fontSize: "14px",
                lineHeight: "22.75px",
                color: "#aaa",
              }}
            >
              기타
            </PretendardText>
          </div>
        </div>
      </div>
    );
  }

  return null;
};

export default CancelReasonCustomTooltip;
